import * as React from 'react';

/** Material UI Packages. */
import { Typography, Tooltip, Box } from '@mui/material';

export default function HeaderWithIcon(props) {
    const { icon, tooltipTitle, sx, ...params } = props;

    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography sx={{ fontSize: '11px', fontWeight: 500, mr: 1, ...sx }}>
                {params.headerName ?? params.groupId}
            </Typography>
            {tooltipTitle && icon && (
                <Tooltip title={tooltipTitle} placement="top" arrow>
                    {icon}
                </Tooltip>
            )}
        </Box>
    );
}

export function PageHeader(props) {
    const { title, icon: Icon, children, sx } = props;

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                fontSize: '17px',
                color: '#003a52',
                fontWeight: 500,
                mb: 2,
                ...sx,
            }}
        >
            {Icon && <Icon sx={{ mr: 1 }} />}
            <Typography sx={{ fontSize: '17px', color: '#003a52', fontWeight: 500, display: 'inline' }}>
                {title}
            </Typography>
            {children}
        </Box>
    );
}
